import React, { useCallback, useEffect, useState } from 'react';
import { array, any, bool, func, object, oneOf, string } from 'prop-types';
import { isParent } from 'utils/dom';
import classNames from 'classnames';

import Button from 'components/Button';
import CheveronUpIcon from 'components/Icon/CheveronUp';
import CheveronDownIcon from 'components/Icon/CheveronDown';
import List from './List';

import './styles.css';

export default function Dropdown(props) {
  const { anchor, caret, children, className, options, valueField, labelField, onChangeSelection, selections, style, multiselect, name, renderOption, showSearch } = props;
  const [expanded, setExpanded] = useState(false);
  const toggle = useCallback((event) => {
    event.preventDefault();
    setExpanded(!expanded);
  });

  useEffect(() => {
    const closeDropdown  = (event) => {
      if (expanded && !isParent(event.target, 'Dropdown_list_search')) {
        setTimeout(() => setExpanded(false), 0);
      }
    };
    document.body.addEventListener('click', closeDropdown);
    return () => {
      document.body.removeEventListener('click', closeDropdown);
    }
  }, [valueField, expanded]);

  return (
    <div className={classNames('Dropdown md:relative', className)}>
      <Button onClick={toggle} type="plain" shape="square" className="block ml-2 overflow-hidden text-secondary hover:text-default" style={style}>
        {caret && !expanded && <CheveronDownIcon className="fill-current float-right mt-1" width={20} height={20} />}
        {caret && expanded && <CheveronUpIcon className="fill-current float-right mt-1" width={20} height={20} />}
        {children}
      </Button>
      {expanded &&
        <List
          name={name}
          anchor={anchor}
          options={options}
          valueField={valueField}
          labelField={labelField}
          onChangeSelection={onChangeSelection}
          selections={selections}
          multiselect={multiselect}
          expanded={expanded}
          setExpanded={setExpanded}
          renderOption={renderOption}
          showSearch={showSearch}
        />
      }
    </div>
  );
}

Dropdown.propTypes = {
  children: any,
  caret: bool,
  options: array,
  anchor: oneOf(['bottom-left', 'bottom-right', 'top-right']),
  name: string,
  valueField: string,
  labelField: string,
  multiselect: bool,
  onChangeSelection: func,
  renderOption: func,
  selections: array,
  showSearch: bool,
  style: object,
};

Dropdown.defaultProps = {
  anchor: 'bottom-right',
  caret: true,
  valueField: 'value',
  labelField: 'label',
  selections: [],
  multiselect: false,
};
